
export default {
  name: 'snow-effect',
};
